import { cloneDeep } from 'lodash'

function entitySetter(current, setImages, setVideos, setOnlineVideos) {
    if (current.images) {
        setImages(current.images)
      }
      if (current.videos) {
        setVideos(current.videos)
      }
      if (current.onlineVideos) {
        setOnlineVideos(current.onlineVideos)
    }
}

export {entitySetter}